/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto;display:flex}dx-data-grid[_ngcontent-%COMP%]{flex:auto}"];
export { styles as styles };
